import React from 'react';
import { Printer, CalendarIcon, PercentIcon, ScanIcon, CheckIcon, MapPinIcon, UsersIcon, GemIcon, HeartIcon, ShieldCheckIcon, PhoneIcon, Instagram, MessageCircleIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
const SERIF = "'Playfair Display', serif";
const SCRIPT = "'Caveat', cursive";
const GOLD = '#c9a96a';
const GOLD_DARK = '#b08e4f';
const CREAM = '#f5efe5';
const CREAM_LIGHT = '#faf5ec';
const CHARCOAL = '#1f1f1f';
const exact = {
  WebkitPrintColorAdjust: 'exact',
  printColorAdjust: 'exact'
} as React.CSSProperties;
export function OrthodonticFlyerUaPage() {
  const handlePrint = () => window.print();
  return <div className="min-h-screen bg-gray-100 p-6 print:p-0 print:bg-white" data-id="element-2677" data-mp="32dt7k3ohq0xd">
      {/* Controls */}
      <div className="no-print max-w-[210mm] mx-auto mb-6 flex items-center justify-between" data-id="element-2678" data-mp="1cywlejf2ptsd">
        <div data-id="element-2679" data-mp="17ztd8q3sr7g6">
          <h1 className="text-xl font-bold text-gray-900" data-id="element-2680" data-mp="1801t8qv7usvl">
            Dentico Clinic — Орто Флаєр (Українською)
          </h1>
          <p className="text-sm text-gray-500 mt-0.5" data-id="element-2681" data-mp="lmdxtb0csr7d">
            A4 vertical · Tip: enable <strong data-id="element-2682" data-mp="qjmibi8z57bs">Background graphics</strong> in
            print settings.
          </p>
        </div>
        <Button onClick={handlePrint} className="gap-2 shadow-md" data-id="element-2683" data-mp="vj8t7l1bybhf">
          <Printer className="w-4 h-4" data-id="element-2684" data-mp="10a8suy1u37nm" />
          Print Flyer
        </Button>
      </div>

      {/* A4 Page */}
      <div className="flyer-page mx-auto shadow-2xl print:shadow-none relative overflow-hidden" style={{
      width: '210mm',
      height: '297mm',
      backgroundColor: CREAM_LIGHT,
      ...exact
    }} data-id="element-2685" data-mp="14c2mimdm3bea">
        {/* === HERO PORTRAIT — bleeds top-right, full height to ~64% === */}
        <div className="absolute top-0 right-0" style={{
        width: '52%',
        height: '64%',
        zIndex: 1,
        ...exact
      }} data-id="element-2686" data-mp="1j7s4m9fof4dq">
          <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1400&q=85" alt="Smiling woman" className="w-full h-full object-cover" style={{
          objectPosition: 'center 25%',
          ...exact
        }} data-id="element-2687" data-mp="3l197z0wrxj2o" />
          {/* Soft fade into cream on left edge */}
          <div className="absolute inset-y-0 left-0 w-2/5" style={{
          background: `linear-gradient(to right, ${CREAM_LIGHT} 0%, rgba(250,245,236,0.5) 30%, rgba(250,245,236,0) 100%)`,
          ...exact
        }} data-id="element-2688" data-mp="3hylkif2t0p0q" />
          {/* Soft fade into cream on bottom */}
          <div className="absolute inset-x-0 bottom-0 h-1/4" style={{
          background: `linear-gradient(to top, ${CREAM_LIGHT} 0%, rgba(250,245,236,0) 100%)`,
          ...exact
        }} data-id="element-2689" data-mp="9hqg2v6cywkj" />
        </div>

        {/* === LOGO TOP === */}
        <div className="absolute top-0 left-0 flex items-center gap-3 pl-10 pt-9" style={{
        zIndex: 10
      }} data-id="element-2690" data-mp="ej62aqk9v94i">
          <div className="rounded-full flex items-center justify-center" style={{
          width: '54px',
          height: '54px',
          border: `1.5px solid ${GOLD}`,
          ...exact
        }} data-id="element-2691" data-mp="125jf56kfvnwv">
            <img src="https://cdn.magicpatterns.com/uploads/oHJPxkkc7f6GgU5uyo3LQX/ChatGPT_Image_Feb_5,_2026,_03_12_40_PM.png" alt="Dentico" className="w-7 h-7 object-contain" data-id="element-2692" data-mp="t3a7cogk28n6" />
          </div>
          <div data-id="element-2693" data-mp="5fithgfd9njs">
            <div className="leading-none" style={{
            fontFamily: SERIF,
            fontWeight: 600,
            fontSize: '36px',
            color: CHARCOAL,
            letterSpacing: '0.06em'
          }} data-id="element-2694" data-mp="5g20w37e4tjk">
              DENTICO
            </div>
            <div className="mt-1.5" style={{
            fontSize: '8.5px',
            color: '#7a7060',
            letterSpacing: '0.3em',
            fontWeight: 500
          }} data-id="element-2695" data-mp="euw8d0joah4">
              DENTAL & AESTHETIC CLINIC
            </div>
          </div>
        </div>

        {/* === HEADLINE LEFT === */}
        <div className="absolute" style={{
        top: '110px',
        left: '40px',
        width: '105mm',
        zIndex: 5
      }} data-id="element-2696" data-mp="p2z0du6zscvr">
          <h1 style={{
          fontFamily: SERIF,
          fontWeight: 800,
          fontSize: '64px',
          lineHeight: 0.95,
          color: CHARCOAL,
          letterSpacing: '-0.015em'
        }} data-id="element-2697" data-mp="f3hwnibaw92f">
            РІВНІ
            <br data-id="element-2698" data-mp="25gfdba1byny4" />
            ЗУБИ.
          </h1>
          <h1 className="mt-3" style={{
          fontFamily: SERIF,
          fontWeight: 700,
          fontStyle: 'italic',
          fontSize: '52px',
          lineHeight: 1.0,
          color: GOLD_DARK,
          letterSpacing: '-0.01em',
          ...exact
        }} data-id="element-2699" data-mp="25f4cnj36lwb8">
            Впевнена
            <br data-id="element-2700" data-mp="2hq53mxcv8qea" />
            посмішка.
          </h1>

          {/* Gold divider */}
          <div className="mt-7 mb-4" style={{
          width: '52px',
          height: '2px',
          backgroundColor: GOLD,
          ...exact
        }} data-id="element-2701" data-mp="2mpi0maxgbdul" />

          <p style={{
          fontSize: '15px',
          color: '#3f3a32',
          lineHeight: 1.55,
          maxWidth: '88mm'
        }} data-id="element-2702" data-mp="1u0aq0dkq2xsz">
            Сучасне ортодонтичне лікування для дітей та дорослих{' '}
            <span style={{
            color: GOLD_DARK,
            fontWeight: 600
          }} data-id="element-2703" data-mp="22zfo5isdgp4m">
              у Лондоні
            </span>
            .
          </p>
        </div>

        {/* === 0% FINANCE BADGE — circular, floating over portrait === */}
        <div className="absolute rounded-full flex flex-col items-center justify-center text-center" style={{
        top: '128mm',
        right: '14mm',
        width: '40mm',
        height: '40mm',
        backgroundColor: GOLD,
        color: '#ffffff',
        zIndex: 6,
        boxShadow: '0 10px 28px rgba(201,169,106,0.45)',
        ...exact
      }} data-id="element-2704" data-mp="1fe0g71x2t1q0">
          <div className="uppercase leading-tight" style={{
          fontSize: '8px',
          letterSpacing: '0.2em',
          fontWeight: 600
        }} data-id="element-2705" data-mp="rn4r4ck08kmg">
            Фінансування
            <br data-id="element-2706" data-mp="10lq9o7ph7zn8" />
            доступне
          </div>
          <div className="leading-none my-1" style={{
          fontFamily: SERIF,
          fontSize: '44px',
          fontWeight: 800
        }} data-id="element-2707" data-mp="cxfara3cca1l">
            0%
          </div>
          <div className="uppercase" style={{
          fontSize: '9px',
          letterSpacing: '0.28em',
          fontWeight: 600
        }} data-id="element-2708" data-mp="2jl5yreyowtg9">
            ВІДСОТКІВ*
          </div>
        </div>

        {/* === FEATURE BLOCKS CARD === */}
        <div className="absolute" style={{
        top: '170mm',
        left: '12mm',
        width: '130mm',
        zIndex: 5
      }} data-id="element-2709" data-mp="2flf95ekwgjdb">
          <div className="rounded-2xl px-3 py-5" style={{
          backgroundColor: '#ffffff',
          boxShadow: '0 6px 24px rgba(0,0,0,0.05)',
          ...exact
        }} data-id="element-2710" data-mp="37bthkva593hl">
            <div className="grid grid-cols-3" data-id="element-2711" data-mp="2y90s8xkiv1ue">
              {[{
              Icon: CalendarIcon,
              title: 'БЕЗКОШТОВНА',
              title2: 'КОНСУЛЬТАЦІЯ',
              desc: 'План лікування\nта огляд'
            }, {
              Icon: PercentIcon,
              title: '0%',
              title2: 'ФІНАНСУВАННЯ',
              desc: 'Зручна оплата\nчастинами'
            }, {
              Icon: ScanIcon,
              title: '3D ЦИФРОВЕ',
              title2: 'СКАНУВАННЯ',
              desc: 'Без старих\nвідбитків'
            }].map((f, i) => <div key={i} className="flex flex-col items-center text-center px-2" style={{
              borderRight: i < 2 ? '1px solid #ece4d3' : 'none',
              ...exact
            }} data-id="element-2712" data-mp="2x8zotbdtbc3x" data-mpi={i}>
                  <f.Icon className="mb-3" style={{
                color: GOLD,
                width: 30,
                height: 30,
                ...exact
              }} strokeWidth={1.3} data-id="element-2713" data-mp="2ikbqwyghuqat" />
                  <div className="uppercase" style={{
                fontSize: '10.5px',
                color: CHARCOAL,
                letterSpacing: '0.16em',
                fontWeight: 700,
                lineHeight: 1.3
              }} data-id="element-2714" data-mp="3jjzjo98z18di">
                    {f.title}
                    <br data-id="element-2715" data-mp="6av5ojvpwsh7" />
                    {f.title2}
                  </div>
                  <div className="mt-2 whitespace-pre-line leading-snug" style={{
                fontSize: '10.5px',
                color: '#6b6253'
              }} data-id="element-2716" data-mp="acgftxgvasnp">
                    {f.desc}
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* === SECTION DIVIDER === */}
        <div className="absolute flex items-center gap-4" style={{
        top: '203mm',
        left: '12mm',
        right: '12mm',
        zIndex: 5
      }} data-id="element-2717" data-mp="u20mp2de9qt3">
          <div className="flex-1 h-px" style={{
          backgroundColor: '#d9c9a3',
          ...exact
        }} data-id="element-2718" data-mp="1yuryg1eb2igf" />
          <span className="uppercase whitespace-nowrap" style={{
          fontSize: '10px',
          color: '#7a6a4a',
          letterSpacing: '0.32em',
          fontWeight: 600
        }} data-id="element-2719" data-mp="28kl7aun2cjgz">
            Оберіть зручний варіант лікування
          </span>
          <div className="flex-1 h-px" style={{
          backgroundColor: '#d9c9a3',
          ...exact
        }} data-id="element-2720" data-mp="2mle63rkee0pw" />
        </div>

        {/* === ORTHODONTIC OPTIONS === */}
        <div className="absolute grid grid-cols-3 gap-3" style={{
        top: '210mm',
        left: '12mm',
        right: '12mm',
        zIndex: 5
      }} data-id="element-2721" data-mp="s7wdhq54ydo0">
          {[{
          img: 'https://images.unsplash.com/photo-1606811971618-4486d14f3f99?auto=format&fit=crop&w=600&q=80',
          title: 'INVISALIGN®',
          desc: 'Прозорі елайнери для\nкомфортного лікування',
          tags: 'Непомітно · Комфортно · Знімні'
        }, {
          img: 'https://images.unsplash.com/photo-1598256989800-fe5f95da9787?auto=format&fit=crop&w=600&q=80',
          title: 'МЕТАЛЕВІ БРЕКЕТИ',
          desc: 'Надійне та ефективне\nвирівнювання',
          tags: 'Надійно · Ефективно · Доступно'
        }, {
          img: 'https://images.unsplash.com/photo-1559591937-abc3a5fab90b?auto=format&fit=crop&w=600&q=80',
          title: 'КЕРАМІЧНІ БРЕКЕТИ',
          desc: 'Більш естетичний та\nнепомітний варіант',
          tags: 'Естетично · Непомітно · Впевнено'
        }].map((o, i) => <div key={i} className="rounded-xl overflow-hidden bg-white" style={{
          boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
          ...exact
        }} data-id="element-2722" data-mp="3grv11deivnhq" data-mpi={i}>
              <img src={o.img} alt={o.title} className="w-full object-cover" style={{
            height: '32mm',
            ...exact
          }} data-id="element-2723" data-mp="36tp1h2g6utg1" />
              <div className="px-3 pt-3 pb-2.5 text-center" data-id="element-2724" data-mp="32svcs6ux9am3">
                <div style={{
              fontFamily: SERIF,
              fontSize: '14px',
              fontWeight: 700,
              color: CHARCOAL,
              letterSpacing: '0.06em'
            }} data-id="element-2725" data-mp="32ug6ju9ewpiw">
                  {o.title}
                </div>
                <div className="mt-1.5 whitespace-pre-line leading-snug" style={{
              fontSize: '10.5px',
              color: '#6b6253'
            }} data-id="element-2726" data-mp="2j44g6cwkbk3l">
                  {o.desc}
                </div>
              </div>
              <div className="flex items-center justify-center gap-1.5 py-1.5" style={{
            backgroundColor: GOLD,
            ...exact
          }} data-id="element-2727" data-mp="29h9x1kogme40">
                <CheckIcon className="w-3 h-3" strokeWidth={2.5} style={{
              color: '#fff',
              ...exact
            }} data-id="element-2728" data-mp="2jdwj2csivb7m" />
                <span style={{
              fontSize: '9px',
              color: '#fff',
              letterSpacing: '0.08em',
              fontWeight: 600
            }} data-id="element-2729" data-mp="2s9cid9c1qikl">
                  {o.tags}
                </span>
              </div>
            </div>)}
        </div>

        {/* === CTA BAR === */}
        <div className="absolute flex items-center px-9" style={{
        top: '256mm',
        left: 0,
        right: 0,
        height: '22mm',
        backgroundColor: CHARCOAL,
        zIndex: 5,
        ...exact
      }} data-id="element-2730" data-mp="3h7xqgdg80xwb">
          <div className="rounded-lg flex items-center justify-center flex-shrink-0" style={{
          width: '50px',
          height: '50px',
          backgroundColor: GOLD,
          ...exact
        }} data-id="element-2731" data-mp="3uyj4nouqcjnv">
            <MessageCircleIcon className="w-6 h-6" strokeWidth={1.8} style={{
            color: '#fff',
            ...exact
          }} data-id="element-2732" data-mp="379qd04l54xz2" />
          </div>
          <div className="ml-4 flex-1" data-id="element-2733" data-mp="mj93ciynzih5">
            <div className="uppercase" style={{
            fontSize: '14px',
            color: '#fff',
            fontWeight: 700,
            letterSpacing: '0.06em'
          }} data-id="element-2734" data-mp="mmesfy7amkcv">
              Запишіться на{' '}
              <span style={{
              color: GOLD,
              ...exact
            }} data-id="element-2735" data-mp="272v0f47bjwno">
                консультацію
              </span>{' '}
              сьогодні!
            </div>
            <div className="mt-1" style={{
            fontSize: '11px',
            color: '#bdb6a8'
          }} data-id="element-2736" data-mp="1taohxbgp1dl2">
              Напишіть нам у WhatsApp або зателефонуйте — ми чекаємо на вас.
            </div>
          </div>

          {/* Hand-drawn arrow */}
          <svg width="50" height="26" viewBox="0 0 50 26" className="flex-shrink-0 mr-2" style={exact} data-id="element-2737" data-mp="1edxgyxrdfttc">
            <path d="M2 18 Q 18 4, 42 10" fill="none" stroke={GOLD} strokeWidth="1.5" strokeLinecap="round" data-id="element-2738" data-mp="38rf9z0ajpivr" />
            <path d="M37 6 L 43 10 L 38 15" fill="none" stroke={GOLD} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-2739" data-mp="170g5emq4fijt" />
          </svg>

          {/* QR */}
          <div className="flex-shrink-0" style={{
          width: '60px',
          height: '60px',
          backgroundColor: '#fff',
          padding: '4px',
          borderRadius: '4px',
          ...exact
        }} data-id="element-2740" data-mp="123ppbzebgmye">
            <img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://wa.me/447371989898&format=png&color=1f1f1f&bgcolor=ffffff" alt="QR" className="w-full h-full object-contain" style={exact} data-id="element-2741" data-mp="1graudyur4w8y" />
          </div>

          <div className="ml-3 flex-shrink-0" style={{
          fontFamily: SCRIPT,
          fontSize: '20px',
          color: GOLD,
          lineHeight: 1.05,
          ...exact
        }} data-id="element-2742" data-mp="9fadtmue8mrt">
            Скануй
            <br data-id="element-2743" data-mp="btfkhs3wfauj" />
            та запишись!
          </div>
        </div>

        {/* === BOTTOM INFO ROW === */}
        <div className="absolute grid grid-cols-5" style={{
        top: '278mm',
        left: 0,
        right: 0,
        height: '13mm',
        backgroundColor: CREAM,
        zIndex: 5,
        ...exact
      }} data-id="element-2744" data-mp="6v4btkpcb6dw">
          {[{
          Icon: MapPinIcon,
          title: 'ANGEL, LONDON',
          desc: '62 Blythe Road, W14 0HB'
        }, {
          Icon: UsersIcon,
          title: 'УКРАЇНОМОВНА',
          desc: 'Ваша рідна мова 🇺🇦'
        }, {
          Icon: ShieldCheckIcon,
          title: 'ДОСВІДЧЕНІ ЛІКАРІ',
          desc: 'Лікування на найвищому рівні'
        }, {
          Icon: GemIcon,
          title: 'СУЧАСНА ТЕХНІКА',
          desc: 'Цифрова стоматологія'
        }, {
          Icon: HeartIcon,
          title: 'ВАША ПОСМІШКА',
          desc: 'Наш пріоритет'
        }].map((b, i) => <div key={i} className="flex items-center gap-2 px-2.5" style={{
          borderRight: i < 4 ? '1px solid #e0d4ba' : 'none',
          ...exact
        }} data-id="element-2745" data-mp="2jyf6egud0i4i" data-mpi={i}>
              <b.Icon className="flex-shrink-0" style={{
            color: GOLD,
            width: 18,
            height: 18,
            ...exact
          }} strokeWidth={1.4} data-id="element-2746" data-mp="2yqpdbc5vfm7t" />
              <div className="leading-tight" data-id="element-2747" data-mp="3cp5rtp9z6h0i">
                <div className="uppercase" style={{
              fontSize: '7.5px',
              color: CHARCOAL,
              fontWeight: 700,
              letterSpacing: '0.13em',
              lineHeight: 1.2
            }} data-id="element-2748" data-mp="3cpyqs42p0283">
                  {b.title}
                </div>
                <div className="mt-0.5" style={{
              fontSize: '7.5px',
              color: '#6b6253',
              lineHeight: 1.3
            }} data-id="element-2749" data-mp="n32k54q395c0">
                  {b.desc}
                </div>
              </div>
            </div>)}
        </div>

        {/* === FOOTER STRIP === */}
        <div className="absolute flex items-center justify-between px-9" style={{
        top: '291mm',
        left: 0,
        right: 0,
        height: '6mm',
        backgroundColor: CHARCOAL,
        zIndex: 5,
        ...exact
      }} data-id="element-2750" data-mp="161oqay0gpmms">
          <div className="flex items-center gap-2" data-id="element-2751" data-mp="2gdcifxye736v">
            <div className="rounded-full flex items-center justify-center" style={{
            width: '20px',
            height: '20px',
            border: `1px solid ${GOLD}`,
            ...exact
          }} data-id="element-2752" data-mp="2gazrivanpiho">
              <img src="https://cdn.magicpatterns.com/uploads/oHJPxkkc7f6GgU5uyo3LQX/ChatGPT_Image_Feb_5,_2026,_03_12_40_PM.png" alt="" className="w-3 h-3 object-contain" style={{
              filter: 'brightness(0) invert(1)',
              ...exact
            }} data-id="element-2753" data-mp="21hd1ryx7vuq4" />
            </div>
            <span style={{
            fontFamily: SERIF,
            fontSize: '12px',
            color: '#fff',
            fontWeight: 600,
            letterSpacing: '0.12em'
          }} data-id="element-2754" data-mp="2kdmp7cu0dxms">
              DENTICO
            </span>
          </div>

          <div className="flex items-center gap-4" data-id="element-2755" data-mp="3ld0wndcdywq4">
            <div className="flex items-center gap-1.5" data-id="element-2756" data-mp="3pdkwwps9aggh">
              <PhoneIcon className="w-3 h-3" strokeWidth={1.6} style={{
              color: GOLD,
              ...exact
            }} data-id="element-2757" data-mp="3pe31c9p2o0zh" />
              <span style={{
              fontSize: '10px',
              color: '#fff'
            }} data-id="element-2758" data-mp="37o163xgqbjh">
                020 4587 6664
              </span>
            </div>
            <div style={{
            width: 1,
            height: 11,
            backgroundColor: '#3a3a3a',
            ...exact
          }} data-id="element-2759" data-mp="c4oijqm479df" />
            <div className="flex items-center gap-1.5" data-id="element-2760" data-mp="lyyq4fjmoe8q">
              <MessageCircleIcon className="w-3 h-3" strokeWidth={1.6} style={{
              color: GOLD,
              ...exact
            }} data-id="element-2761" data-mp="qx05apdxntex" />
              <span style={{
              fontSize: '10px',
              color: '#fff'
            }} data-id="element-2762" data-mp="676003q04pjw">
                0737 198 9898
              </span>
            </div>
            <div style={{
            width: 1,
            height: 11,
            backgroundColor: '#3a3a3a',
            ...exact
          }} data-id="element-2763" data-mp="fysgofl3zgu1" />
            <div className="flex items-center gap-1.5" data-id="element-2764" data-mp="ozgx1gxz5ta3">
              <Instagram className="w-3 h-3" strokeWidth={1.6} style={{
              color: GOLD,
              ...exact
            }} data-id="element-2765" data-mp="jx9gsf643r1y" />
              <span style={{
              fontSize: '10px',
              color: '#fff'
            }} data-id="element-2766" data-mp="txs79ss6m5su">
                @dentico.london
              </span>
            </div>
          </div>
        </div>
      </div>

      <style data-id="element-2767" data-mp="1b61kpju1rq2y">{`
        @media print {
          @page {
            size: A4 portrait;
            margin: 0;
          }
          html, body {
            margin: 0;
            padding: 0;
            background: white;
          }
          .no-print {
            display: none !important;
          }
          .flyer-page {
            width: 210mm !important;
            height: 297mm !important;
            box-shadow: none !important;
            margin: 0 !important;
            overflow: hidden !important;
          }
        }
      `}</style>
    </div>;
}